const google = window.google

const SELECTORS = Selectors({
  map: '[data-map]'
})

const props = {
  $elements: document.querySelectorAll(SELECTORS.map)
}

const fn = {
  init: () => {
    props.$elements.forEach($el => {
      const center = new google.maps.LatLng($el.dataset.lat, $el.dataset.lng)

      const mapOptions = {
        center,
        zoom: 14,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        draggable: false,
        scrollwheel: false
      }

      const map = new google.maps.Map($el, mapOptions)

      if ($el.dataset.showMarker) {
        new google.maps.Marker({
          position: center,
          map: map
        })
      }
    })
  }
}

export default {
  can: () => props.$elements.length,
  run: fn.init
}
